import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import RulerIcon from '../../../../MyComponents/icons/RulerIcon';
import ProtractorIcon from '../../../../MyComponents/icons/ProtractorIcon';
import SectionChapter from '../../SectionChapter';
import CompassIcon from '../../../../MyComponents/icons/CompassIcon';
import TrySquareIcon from '../../../../MyComponents/icons/TrySquareIcon';
import MoveIcon from '../../../../MyComponents/icons/MoveIcon';
import RotateIconNew from '../../../../MyComponents/icons/RotateIconNew';
import PinIcon from '../../../../MyComponents/icons/PinIcon';
import CompassPenIcon from '../../../../MyComponents/icons/CompassPenIcon';
import { DeleteForever } from '@material-ui/icons';

const iconStyle = { verticalAlign: 'middle', fontSize: '1.2rem', margin: '0 2px' };

const GeometryManagement = ({ language, classes, refs }) => {
    let instruments = [
        {
            id: 'redesign.page.tutorial.manageLesson.geometry.explanation1',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="redesign.tutorial.geometry.line1"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <RulerIcon className={classes.sampleFab} />
                        </Typography>
                        <Typography component="div">
                            <ul style={{ paddingLeft: '1.2rem', margin: '0.5rem 0' }}>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line1.move" />
                                    <MoveIcon style={iconStyle} color="primary" />
                                </li>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line1.rotate" />
                                    <RotateIconNew style={iconStyle} color="primary" />
                                </li>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line1.delete" />
                                    <DeleteForever style={iconStyle} color="secondary" />
                                </li>
                            </ul>
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/RulerRotate.jpg`,
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/RulerMove.jpg`,
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/RulerDelete.jpg`,
            ],
        },
        {
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="redesign.tutorial.geometry.line2"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <ProtractorIcon className={classes.sampleFab} />
                        </Typography>
                        <Typography component="div">
                            <ul style={{ paddingLeft: '1.2rem', margin: '0.5rem 0' }}>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line2.move" />
                                    <MoveIcon style={iconStyle} color="primary" />
                                </li>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line2.rotate" />
                                    <RotateIconNew style={iconStyle} color="primary" />
                                </li>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line2.delete" />
                                    <DeleteForever style={iconStyle} color="secondary" />
                                </li>
                            </ul>
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/ProtractorRotate.jpg`,
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/ProtractorMove.jpg`,
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/ProtractorDelete.jpg`,
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/Geometry.jpg`,
            ],
        },
        {
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="redesign.tutorial.geometry.line3"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <CompassIcon className={classes.sampleFab} />
                        </Typography>
                        <Typography component="div">
                            <ul style={{ paddingLeft: '1.2rem', margin: '0.5rem 0' }}>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line3.pin" />
                                    <PinIcon style={iconStyle} color="primary" />
                                </li>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line3.move" />
                                    <MoveIcon style={iconStyle} color="primary" />
                                </li>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line3.draw" />
                                    <CompassPenIcon style={iconStyle} color="primary" />
                                </li>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line3.delete" />
                                    <DeleteForever style={iconStyle} color="secondary" />
                                </li>
                            </ul>
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/MoveCompass.png`,
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/ResizeCompass.png`,
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/DrawCompass.png`,
            ],
        },
        {
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="redesign.tutorial.geometry.line4"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <TrySquareIcon className={classes.sampleFab} />
                        </Typography>
                        <Typography component="div">
                            <ul style={{ paddingLeft: '1.2rem', margin: '0.5rem 0' }}>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line4.move" />
                                    <MoveIcon style={iconStyle} color="primary" />
                                </li>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line4.rotate" />
                                    <RotateIconNew style={iconStyle} color="primary" />
                                </li>
                                <li>
                                    <FormattedMessage id="redesign.tutorial.geometry.line4.delete" />
                                    <DeleteForever style={iconStyle} color="secondary" />
                                </li>
                            </ul>
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/TrySquare.jpg`,
            ],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageLesson-geometry'}
            title={'redesign.page.tutorial.manageLesson.geometry.title'}
            explanations={instruments}
            imageTop={false}
        />
    );
};

export default GeometryManagement;
